import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ScatterPlotComponent } from './shared/scatter-plot/scatter-plot.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { SelectionPanelComponent } from './free-selection-panel/selection-panel.component'
import { PlotDataSelectionComponent } from './shared/plot-data-selection/plot-data-selection.component'
import { SelectionManipulationComponent } from './shared/selection-manipulation/selection-manipulation.component'
import { UiLibraryModule } from '../ui-library/ui-library.module'
import { SavedFreeSelectionsComponent } from './free-selection-panel/saved-free-selections/saved-free-selections.component'
import { LetDirective } from '@ngrx/component'
import { SaveSelectionAsDialogComponent } from './save-selection-as-dialog/save-selection-as-dialog.component'
import { TsneJobComponent } from './shared/tsne-job/tsne-job.component'
import { HierarchicalSelectionPanelComponent } from './hierarchical-selection-panel/hierarchical-selection-panel.component'
import { SavedHierarchicalSelectionRootsComponent } from './hierarchical-selection-panel/saved-hierarchical-selection-roots/saved-hierarchical-selection-roots.component'
import { SavedHierarchicalSelectionNodesComponent } from './hierarchical-selection-panel/saved-hierarchical-selection-nodes/saved-hierarchical-selection-nodes.component'
import { SegObjectPropertyMapPanelComponent } from './segobjectpropertymap-panel/segobjectpropertymap-panel.component'
import { SharedModule } from '../shared/shared.module'
import { UmapJobComponent } from './shared/umap-job/umap-job.component'
import { AutoCellDetectComponent } from './shared/auto-cell-detect/auto-cell-detect.component'
import { AddPropertiesDialogComponent } from './add-properties-dialog/add-properties-dialog.component'
import { PlottingPanelComponent } from './plotting-panel/plotting-panel.component'
import { CreateGroupDialogComponent } from './plotting-panel/create-group-dialog/create-group-dialog.component'
@NgModule({
    declarations: [
        ScatterPlotComponent,
        SelectionPanelComponent,
        PlotDataSelectionComponent,
        SelectionManipulationComponent,
        SavedFreeSelectionsComponent,
        SaveSelectionAsDialogComponent,
        TsneJobComponent,
        HierarchicalSelectionPanelComponent,
        SavedHierarchicalSelectionRootsComponent,
        SavedHierarchicalSelectionNodesComponent,
        SegObjectPropertyMapPanelComponent,
        UmapJobComponent,
        AutoCellDetectComponent,
        AddPropertiesDialogComponent,
        PlottingPanelComponent,
        CreateGroupDialogComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        UiLibraryModule,
        LetDirective,
        ReactiveFormsModule,
        SharedModule,
    ],
    exports: [
        SelectionPanelComponent,
        PlotDataSelectionComponent,
        ScatterPlotComponent,
        SelectionManipulationComponent,
        HierarchicalSelectionPanelComponent,
        SavedHierarchicalSelectionRootsComponent,
        SegObjectPropertyMapPanelComponent,
        AutoCellDetectComponent,
        PlottingPanelComponent,
    ],
})
export class SelectionModule {}
